import React from 'react'
import cx from 'classnames'
import questions from 'images/gma/svgs.json'
import * as R from 'ramda'

const svgImageData = (question, value) =>
  R.propOr(
    questions['questionmark'],
    `q${question.toString().padStart(2, '0')}-${value}`,
    questions,
  )

const Cell = ({
  question = '1',
  active,
  placeholder,
  value,
  option = false,
  selected = false,
  onClick,
  ...props
}) => (
  <svg
    onClick={onClick}
    className={cx('Cell', { selected, clickable: onClick })}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    {option && <circle className="Hole" cx="0.5" cy="0.5" r="0.5" />}
    <image
      className="Symbol"
      preserveAspectRatio="none"
      x="0"
      y="0"
      width="1"
      height="1"
      xlinkHref={svgImageData(question, value)}
    />
  </svg>
)

export default Cell
